import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { APP_ORIGIN } from '@shared/origin'

// The legacy hosts serve the same pages and are never redirected, so every page
// names its faro.dance URL as canonical. Pages served by an OG function
// (/events, /artists) already carry the same tag; this keeps it in step on
// client navigation. The query string is dropped: filters and invite params
// are views of the same page.
export function useCanonicalLink() {
  const { pathname } = useLocation()
  useEffect(() => {
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (!link) {
      link = document.createElement('link')
      link.rel = 'canonical'
      document.head.appendChild(link)
    }
    link.href = APP_ORIGIN + pathname
  }, [pathname])
}

/** Keeps a page out of search results while it's mounted — for soft 404s the SPA serves with a 200. */
export function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex'
    document.head.appendChild(meta)
    return () => meta.remove()
  }, [])
}
